// [EDITED: KPI Task - Mahesh Sharma]
import moment from 'moment-timezone'; // [EDITED: KPI Task - Mahesh Sharma]

/**
 * Financial Year (FY) Week Calculation Utility (Frontend)
 * Aligned to the Indian Financial Year (April 1 to March 31).
 * April 2026 starts the evaluation cycle as Month 1 / Week 1 (FY 2026-27 Week 1).
 */

/**
 * Returns the Financial Year string (e.g. "2026-2027") for a date or ISO week.
 * Uses ISO Thursday to accurately determine the week's financial year.
 */
export function getFinancialYear(dateInput = new Date()) { // [EDITED: KPI Task - Mahesh Sharma]
  const d = moment(dateInput); // [EDITED: KPI Task - Mahesh Sharma]
  const thursday = d.clone().isoWeekday(4); // Day 4 (Thursday) determines week's FY // [EDITED: KPI Task - Mahesh Sharma]
  const year = thursday.year(); // [EDITED: KPI Task - Mahesh Sharma]
  const month = thursday.month(); // 0 = Jan, 3 = April // [EDITED: KPI Task - Mahesh Sharma]
  
  if (month >= 3) { // April onwards // [EDITED: KPI Task - Mahesh Sharma]
    return `${year}-${year + 1}`; // [EDITED: KPI Task - Mahesh Sharma]
  } else { // Jan, Feb, Mar // [EDITED: KPI Task - Mahesh Sharma]
    return `${year - 1}-${year}`; // [EDITED: KPI Task - Mahesh Sharma]
  } // [EDITED: KPI Task - Mahesh Sharma]
} // [EDITED: KPI Task - Mahesh Sharma]

/**
 * Calculates the FY Week number (1 to 52) where April contains Week 1.
 */
export function getFYWeekNumber(dateInput = new Date()) { // [EDITED: KPI Task - Mahesh Sharma]
  const d = moment(dateInput); // [EDITED: KPI Task - Mahesh Sharma]
  const thursday = d.clone().isoWeekday(4); // [EDITED: KPI Task - Mahesh Sharma]
  const fyStartYear = thursday.month() >= 3 ? thursday.year() : thursday.year() - 1; // [EDITED: KPI Task - Mahesh Sharma]
  const fyStartDate = moment(`${fyStartYear}-04-01`).startOf('isoWeek'); // Week containing April 1 // [EDITED: KPI Task - Mahesh Sharma]
  
  const diffWeeks = thursday.clone().startOf('isoWeek').diff(fyStartDate, 'weeks') + 1; // [EDITED: KPI Task - Mahesh Sharma]
  return Math.max(1, diffWeeks); // [EDITED: KPI Task - Mahesh Sharma]
} // [EDITED: KPI Task - Mahesh Sharma]

/**
 * Generates options for FY dropdowns (1 to 52).
 */
export function getFYWeekOptions(fyStartYear = 2026) { // [EDITED: KPI Task - Mahesh Sharma]
  const options = []; // [EDITED: KPI Task - Mahesh Sharma]
  const fyStartDate = moment(`${fyStartYear}-04-01`).startOf('isoWeek'); // [EDITED: KPI Task - Mahesh Sharma]
  
  for (let w = 1; w <= 52; w++) { // [EDITED: KPI Task - Mahesh Sharma]
    const weekStart = fyStartDate.clone().add(w - 1, 'weeks').startOf('isoWeek'); // [EDITED: KPI Task - Mahesh Sharma]
    const weekEnd = weekStart.clone().endOf('isoWeek'); // [EDITED: KPI Task - Mahesh Sharma]
    const isoVal = `${weekStart.isoWeekYear()}-W${String(weekStart.isoWeek()).padStart(2, '0')}`; // [EDITED: KPI Task - Mahesh Sharma]
    
    options.push({ // [EDITED: KPI Task - Mahesh Sharma]
      value: isoVal, // [EDITED: KPI Task - Mahesh Sharma]
      fyWeekNumber: w, // [EDITED: KPI Task - Mahesh Sharma]
      startDate: weekStart.format('YYYY-MM-DD'), // [EDITED: KPI Task - Mahesh Sharma]
      endDate: weekEnd.format('YYYY-MM-DD'), // [EDITED: KPI Task - Mahesh Sharma]
      label: `FY ${fyStartYear}-${String(fyStartYear + 1).slice(-2)} Week ${w} (${weekStart.format('DD MMM')} - ${weekEnd.format('DD MMM YYYY')})` // [EDITED: KPI Task - Mahesh Sharma]
    }); // [EDITED: KPI Task - Mahesh Sharma]
  } // [EDITED: KPI Task - Mahesh Sharma]
  
  return options; // [EDITED: KPI Task - Mahesh Sharma]
} // [EDITED: KPI Task - Mahesh Sharma]

/**
 * Converts any ISO week string (e.g. '2026-W14') to a readable Financial Year label:
 * e.g. "FY 2026-27 Week 1 (30 Mar - 05 Apr 2026)"
 */
export function formatFYWeekLabel(isoWeekString) { // [EDITED: KPI Task - Mahesh Sharma]
  if (!isoWeekString) return ''; // [EDITED: KPI Task - Mahesh Sharma]
  
  let targetMoment; // [EDITED: KPI Task - Mahesh Sharma]
  if (typeof isoWeekString === 'string' && isoWeekString.includes('W')) { // [EDITED: KPI Task - Mahesh Sharma]
    const parts = isoWeekString.split('W'); // [EDITED: KPI Task - Mahesh Sharma]
    const year = parseInt(parts[0].replace(/[^0-9]/g, ''), 10); // [EDITED: KPI Task - Mahesh Sharma]
    const weekNo = parseInt(parts[1], 10); // [EDITED: KPI Task - Mahesh Sharma]
    targetMoment = moment().isoWeekYear(year).isoWeek(weekNo); // [EDITED: KPI Task - Mahesh Sharma]
  } else { // [EDITED: KPI Task - Mahesh Sharma]
    targetMoment = moment(isoWeekString); // [EDITED: KPI Task - Mahesh Sharma]
  } // [EDITED: KPI Task - Mahesh Sharma]

  const start = targetMoment.clone().startOf('isoWeek'); // [EDITED: KPI Task - Mahesh Sharma]
  const end = targetMoment.clone().endOf('isoWeek'); // [EDITED: KPI Task - Mahesh Sharma]
  const thursday = targetMoment.clone().isoWeekday(4); // [EDITED: KPI Task - Mahesh Sharma]
  
  const fyWeek = getFYWeekNumber(thursday); // [EDITED: KPI Task - Mahesh Sharma]
  const fyStartYear = thursday.month() >= 3 ? thursday.year() : thursday.year() - 1; // [EDITED: KPI Task - Mahesh Sharma]
  
  return `FY ${fyStartYear}-${String(fyStartYear + 1).slice(-2)} Week ${fyWeek} (${start.format('DD MMM')} - ${end.format('DD MMM YYYY')})`; // [EDITED: KPI Task - Mahesh Sharma]
} // [EDITED: KPI Task - Mahesh Sharma]

// "FY 2026-27 Week 26" - the label without the date range. Short enough for
// an Excel sheet name (31-char limit) and, with spaces swapped for
// underscores, safe in a filename.
export function formatFYWeekShort(isoWeekString) {
  const full = formatFYWeekLabel(isoWeekString);
  return full ? full.split(' (')[0] : '';
}
